<template>
  <div class="home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <div class="landing-page shadow margin-between-sections">
      <div class="container content-bg">
        <h1 class="main-title text-white">
          <!-- <strong> -->
          Hire Freelancers, Get Your Work Done, Start Growing!
          <!-- </strong> -->
        </h1>
        <p style="font-weight:20;font-size: 18px;" class="text-center text-white">Hire freelnacers to your dream's project or start working on projects as a freelancer.</p>
        <router-link id="rl" class="btn btn-lg mx-2 primary" to="/login"
          ><strong>Log In</strong></router-link
        >
        <router-link id="rl" class="btn btn-lg mx-2 primary" to="/register"
          ><strong>Sign Up</strong></router-link
        >
        <p class="text-white text-right credit-img-owner">Photo by <a href="https://www.pexels.com/@danny-meneses-340146">Danny Meneses</a> from Pexels</p>
      </div>
      <br />
    </div>

    <!------------------------------------------------------------>
    <div class="container landing-page-3 margin-between-sections">
      <div class="row justify-content-center">
        <div class="col-md-3 p-4 m-2 card shadow">
          <i style="font-size:40px;" class="fas text-center mb-4 fa-code"></i>
          <h4 class="text-center m-2">Friendy GraphQL API</h4>
          <p style="font-weight:100" class="text-center text-dark m-2">
            You can use our data to build an application for your own for
            improve your skills as a front end developer! or use them for data
            science purposes.
          </p>
        </div>
        <div class="col-md-3 p-4 m-2 card shadow">
          <i
            style="font-size:40px;"
            class="fas text-center mb-4 fa-credit-card"
          ></i>
          <h4 class="text-center m-2">
            No Payment card <strong>required</strong>
          </h4>
          <p style="font-weight:100" class="text-center text-dark m-2">
            yes no payment card required to open up a new account, just fill the
            inputs and there you go you can post projects and hire freelancers.
          </p>
        </div>
        <div class="col-md-3 p-4 m-2 card shadow">
          <i
            style="font-size:40px;"
            class="fas text-center mb-4 fa-code-branch"
          ></i>
          <h4 class="text-center m-2">Open source project!</h4>
          <p style="font-weight:100" class="text-center text-dark m-2">
            This is an open source project! you could see whats going on under
            the hood! or you can contribute as a developer.
          </p>
        </div>
      </div>
    </div>

    <!-------------------------------------------------------------->
    <div class="container landing-page-1 margin-between-sections">
      <div class="row m-2 justify-content-center">
        <div class="col-md-5 svg-section m-2">
          <svg
            id="f5754dbe-bb36-43e2-9e63-0bb9c441defe"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 1184.11 743.5"
          >
            <title>team page</title>
            <path
              d="M231.37,576.52l-6.29-3.91c-.6-.37-1.19-.77-1.79-1.15a59.86,59.86,0,0,0,6.05-116.62l.31,24.66L216.1,452.67h-.17a59.87,59.87,0,0,0-62.58,57c-.06,1.15,0,2.27,0,3.4-4.71-5.38-9-11.15-11.83-17.47-5.73-12.79-5.84-27.28-5.39-44.9.9-34.9,2.41-70.08,4.37-105.14a59.85,59.85,0,0,0,53.16-56.64c.08-1.83.05-3.63,0-5.43,0-.45,0-.89-.07-1.34-.12-1.74-.28-3.46-.55-5.16,0-.28-.1-.55-.15-.82-.24-1.44-.54-2.86-.88-4.26-.13-.53-.26-1.05-.4-1.57-.42-1.53-.88-3-1.42-4.52-.18-.49-.38-1-.58-1.46-.42-1.09-.88-2.17-1.37-3.23-.26-.56-.51-1.12-.78-1.67-.08-.14-.13-.29-.21-.43l0,0a59.84,59.84,0,0,0-70.28-30.36l.4,32.1-13.4-26.52a59.57,59.57,0,0,0-28.55,64.51H75.3c.09.43.22.84.32,1.26.19.79.39,1.57.61,2.35.29,1,.6,2,.93,3,.25.74.49,1.47.77,2.2.41,1.06.87,2.09,1.33,3.12.27.6.51,1.22.8,1.81q1.14,2.32,2.48,4.53c.31.52.66,1,1,1.51.64,1,1.28,2,2,2.93.43.59.89,1.16,1.34,1.73.66.83,1.33,1.65,2,2.44.49.57,1,1.12,1.51,1.66.74.78,1.49,1.53,2.27,2.26.52.49,1,1,1.57,1.46.88.79,1.8,1.53,2.73,2.26.47.37.93.75,1.41,1.11,1.42,1,2.88,2,4.39,3,.28.17.59.31.87.48,1.27.74,2.55,1.45,3.87,2.09.57.28,1.15.53,1.73.79,1.08.48,2.17.95,3.29,1.38l2,.7c1.1.37,2.22.72,3.35,1,.66.18,1.33.37,2,.53,1.22.29,2.47.53,3.73.75l.24.05q-1.23,22.19-2.2,44.39a59.83,59.83,0,0,0-83.07-26l10.58,29-21.77-20.9A59.66,59.66,0,0,0,8,413a58.5,58.5,0,0,0,1.52,16.49,59.84,59.84,0,0,0,110.06,16.3c0,1.5-.1,3-.14,4.51-.4,15.54-.9,34.88,6.85,52.15,5.25,11.7,13.69,21.21,22,29.73,5.43,5.54,11.06,10.91,16.83,16.1a60.09,60.09,0,0,0,21.62,18c9.48,7.3,19.3,14.17,29.45,20.51l6.34,3.94c5.7,3.53,11.54,7.16,17.26,10.93-1-.1-2-.21-3-.26a59.89,59.89,0,0,0-58.94,39l37.4,30.43-41.14-9.54A59.89,59.89,0,0,0,260,715.13l-2.78,3.45q-2.76,3.43-5.45,6.82c-24.34,30.83-31.11,60.09-19.06,82.4l14.66-7.91c-11.73-21.72,5.91-49.52,17.47-64.16q2.64-3.33,5.36-6.7c15.55-19.32,33.17-41.22,32.74-68.08C302.26,620.46,263,596.1,231.37,576.52Z"
              transform="translate(-7.95 -78.25)"
              fill="#f2f2f2"
            />
            <path
              d="M913.31,515.26l7.84-4.88c.75-.47,1.48-1,2.23-1.44a74.69,74.69,0,0,1-62-70.11,74,74,0,0,1,6.45-34,74.8,74.8,0,0,1,48-41.38l-.39,30.77,16.91-33.47.2,0a74.7,74.7,0,0,1,78.09,71.13c.07,1.43,0,2.83,0,4.24,5.89-6.71,11.23-13.91,14.76-21.79,7.16-16,7.3-34,6.73-56-1.12-43.55-3-87.43-5.45-131.17a74.66,74.66,0,0,1-66.32-70.67c-.1-2.28-.07-4.53,0-6.77q0-.84.09-1.68c.14-2.17.35-4.32.67-6.43.05-.35.14-.69.19-1q.46-2.7,1.11-5.32c.16-.65.32-1.31.49-2,.53-1.9,1.1-3.79,1.77-5.63.22-.62.48-1.21.72-1.82.54-1.37,1.11-2.71,1.72-4,.32-.69.63-1.39,1-2.08.08-.17.16-.36.25-.53l0,0a74.6,74.6,0,0,1,87.68-37.87l-.5,40,16.72-33.08a74.27,74.27,0,0,1,35.61,80.48h.09c-.12.53-.29,1-.41,1.57-.24,1-.49,2-.76,2.93-.35,1.25-.75,2.47-1.16,3.69-.31.92-.61,1.84-1,2.75-.51,1.32-1.08,2.61-1.66,3.89-.34.75-.64,1.52-1,2.26-.95,1.93-2,3.82-3.09,5.65-.38.65-.82,1.26-1.23,1.89-.8,1.24-1.61,2.46-2.48,3.65-.54.74-1.11,1.44-1.67,2.16-.82,1-1.65,2.06-2.53,3.05q-.91,1-1.89,2.07c-.91,1-1.86,1.9-2.82,2.81-.65.62-1.29,1.24-2,1.83-1.11,1-2.25,1.9-3.42,2.81-.58.46-1.15.95-1.75,1.39-1.77,1.3-3.59,2.54-5.48,3.69-.35.21-.73.39-1.09.6q-2.36,1.4-4.82,2.61c-.71.35-1.44.65-2.16,1-1.35.61-2.71,1.19-4.1,1.72-.82.31-1.64.6-2.46.88-1.38.47-2.77.89-4.18,1.28-.83.23-1.66.46-2.51.67-1.53.36-3.08.66-4.65.93l-.31.06q1.56,27.69,2.75,55.39a74.62,74.62,0,0,1,103.64-32.4l-13.19,36.16,27.15-26.07A74.4,74.4,0,0,1,1192,311.2a72.94,72.94,0,0,1-1.89,20.57,74.66,74.66,0,0,1-137.32,20.34c0,1.87.13,3.76.18,5.63.5,19.39,1.12,43.52-8.54,65.06-6.55,14.61-17.09,26.46-27.51,37.09q-10.17,10.38-21,20.09a74.94,74.94,0,0,1-27,22.43c-11.83,9.11-24.08,17.68-36.74,25.6l-7.91,4.91c-7.11,4.4-14.39,8.93-21.54,13.63,1.26-.12,2.5-.26,3.78-.32A74.72,74.72,0,0,1,980,594.85l-46.66,38,51.33-11.89a74.73,74.73,0,0,1-107.08,67.26c1.16,1.44,2.31,2.88,3.47,4.31,2.29,2.85,4.58,5.69,6.81,8.51,30.36,38.45,38.81,75,23.77,102.8l-18.28-9.87c14.63-27.1-7.38-61.78-21.81-80-2.19-2.77-4.43-5.56-6.68-8.36-19.4-24.1-41.39-51.42-40.85-84.93C824.86,570.07,873.9,539.68,913.31,515.26Z"
              transform="translate(-7.95 -78.25)"
              fill="#f2f2f2"
            />
            <ellipse cx="584.3" cy="716" rx="514" ry="27.5" fill="#3f3d56" />
            <ellipse cx="583.3" cy="707.5" rx="460" ry="22" opacity="0.2" />
            <path
              d="M1029.24,251.46V780a7.21,7.21,0,0,1-7.21,7.21H162.44a7.2,7.2,0,0,1-7.2-7.21V251.46a7.2,7.2,0,0,1,7.2-7.21H1022A7.21,7.21,0,0,1,1029.24,251.46Z"
              transform="translate(-7.95 -78.25)"
              fill="#3f3d56"
            />
            <path
              d="M1029.24,249.06v16.19h-874V249.06a4.81,4.81,0,0,1,4.81-4.81h864.38A4.81,4.81,0,0,1,1029.24,249.06Z"
              transform="translate(-7.95 -78.25)"
              fill="#cbceda"
            />
            <circle
              cx="163.29"
              cy="176"
              r="5"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <circle
              cx="177.29"
              cy="176"
              r="5"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <circle
              cx="191.29"
              cy="176"
              r="5"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <rect
              x="451.3"
              y="239.5"
              width="266"
              height="14"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.2"
            />
            <rect
              x="230.3"
              y="381.5"
              width="205"
              height="240"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.2"
            />
            <rect
              x="481.3"
              y="381.5"
              width="205"
              height="240"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.2"
            />
            <rect
              x="740.24"
              y="459.75"
              width="205"
              height="240"
              transform="translate(1677.54 1081.25) rotate(-180)"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.2"
            />
            <path
              d="M331.58,581.73c-.61,3.61-4.18,5.88-7.55,7.29s-7.14,2.58-9.3,5.53c-2.91,4-1.69,9.73,1,13.88,3.05,4.76,7.67,8.27,12.19,11.67a22,22,0,0,0,6.6,3.85,19.62,19.62,0,0,0,5.62.6,102.48,102.48,0,0,0,18.17-1.63c7.69-1.4,15.91-4.2,20-10.88,3.32-5.47,3.11-12.3,2.79-18.7-3.62-.31-6.86-2.28-9.94-4.19-3.64-2.26-7.57-4.89-8.75-9-1.24-4.31.74-9.63-2.21-13-2-2.28-5.39-2.55-8.41-2.63q-6.15-.16-12.29-.17c-2.82,0-9.12-1.18-11.44.7C323.79,568.46,332.35,577.15,331.58,581.73Z"
              transform="translate(-7.95 -78.25)"
              fill="#a0616a"
            />
            <path
              d="M331.58,581.73c-.61,3.61-4.18,5.88-7.55,7.29s-7.14,2.58-9.3,5.53c-2.91,4-1.69,9.73,1,13.88,3.05,4.76,7.67,8.27,12.19,11.67a22,22,0,0,0,6.6,3.85,19.62,19.62,0,0,0,5.62.6,102.48,102.48,0,0,0,18.17-1.63c7.69-1.4,15.91-4.2,20-10.88,3.32-5.47,3.11-12.3,2.79-18.7-3.62-.31-6.86-2.28-9.94-4.19-3.64-2.26-7.57-4.89-8.75-9-1.24-4.31.74-9.63-2.21-13-2-2.28-5.39-2.55-8.41-2.63q-6.15-.16-12.29-.17c-2.82,0-9.12-1.18-11.44.7C323.79,568.46,332.35,577.15,331.58,581.73Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <circle cx="337.6" cy="472.09" r="29.33" fill="#a0616a" />
            <path
              d="M406.84,621.52a12.64,12.64,0,0,1-1.65,5,8.55,8.55,0,0,1-.9,1.16c-1.65,1.81-4,3-6.13,4.27-6,3.65-12.73,8.4-13.85,15.35a52.6,52.6,0,0,1-1.51,6.4c-1.4,4.76-3.23,9.44-4.3,14.2a32.28,32.28,0,0,0-.89,8.43,25.57,25.57,0,0,0,.24,2.65c.95,6.74,4.41,12.79,8.48,18.54.44.62.88,1.24,1.33,1.85l.29.39H292.21c.16-.61.32-1.21.47-1.82a2.86,2.86,0,0,1,.07-.28c.95-3.81,1.78-7.64,2.36-11.5A73.2,73.2,0,0,0,296,675.8c0-3,.66-6.32,3.17-8,.17-.61.33-1.23.49-1.84a57.15,57.15,0,0,0-.14-27.63c-.14-.56-.3-1.12-.45-1.68-.07-.25-.15-.5-.22-.75a81.93,81.93,0,0,1-2.12-8.11c-.59-3.27-.72-6.75-2.46-9.57s-4.77-4.47-7.46-6.38a17.1,17.1,0,0,1-3.53-3.21h0a7.88,7.88,0,0,1-1.9-4.6,6.8,6.8,0,0,1,.11-1.5,11.51,11.51,0,0,1,3.05-5.45c6.08-6.69,15.37-9.5,24.5-9.62h0c1.41,0,2.81,0,4.2.12a11.83,11.83,0,0,1,4.71,1.06,7.15,7.15,0,0,1,2.35,1.94,11.64,11.64,0,0,1,2,3.78,21,21,0,0,1,.8,3.38c.56,3.57.68,7.37,2.56,10.45,3.41,5.58,11.18,6.6,17.6,5.39a39.7,39.7,0,0,0,27.23-20,36.74,36.74,0,0,1,2-3.63,9.07,9.07,0,0,1,1.36-1.61,55.81,55.81,0,0,1,24.37,11,26.62,26.62,0,0,1,5.78,6C407,610.08,407.68,616,406.84,621.52Z"
              transform="translate(-7.95 -78.25)"
              fill="#f2f2f2"
            />
            <path
              d="M409.84,681.91a28.16,28.16,0,0,1-3.67,7.86,18.92,18.92,0,0,1-4.24,5.42c-3.55,2.79-8.46,2.73-13,2.47l-.36,0-2.25-.13-12.91-.77a72.77,72.77,0,0,1-10.2-1.09c-.9-.18-1.79-.4-2.68-.64-5-1.34-9.89-3.34-15.06-3.63-1.5-.09-3,0-4.53,0h-.42a22.53,22.53,0,0,1-3-.2c-1.64-.24-3.25-.76-4.92-.84-4.28-.22-8.06,2.35-11.71,4.69l-1,.62a45,45,0,0,1-8.28,4.12H294.27a5.72,5.72,0,0,1-.81-.75,6.23,6.23,0,0,1-.78-1.07c-.05-.09-.1-.18-.14-.27a9.12,9.12,0,0,1,0-7.71,15.09,15.09,0,0,1,2.53-3.8,35,35,0,0,1,3.66-3.44c6.74-5.62,14.49-10.36,23.11-12,.6-.11,1.21-.21,1.81-.29a80.26,80.26,0,0,1,13-.43l4.07.08,17.05.35h.47c6.85.13,14.05.18,20.24-2.55a23.77,23.77,0,0,0,2.3-1.18,4.33,4.33,0,0,0,1.59-1.38,4.77,4.77,0,0,0,.47-2.6l-.06-9-.12-17.35h0q0-6.39-.08-12.77a8.77,8.77,0,0,1,2.45-7.27c2.49-3.13,8.56-14.18,12.86-14.36a3.46,3.46,0,0,1,2.15.6h0c3.66,2.44,3.68,11.69,3.77,14.81q.15,5.17.45,10.33a350.86,350.86,0,0,0,5,42C410,673.73,410.8,677.91,409.84,681.91Z"
              transform="translate(-7.95 -78.25)"
              fill="#a0616a"
            />
            <path
              d="M409.84,681.91a28.16,28.16,0,0,1-3.67,7.86,18.92,18.92,0,0,1-4.24,5.42c-3.55,2.79-8.46,2.73-13,2.47l-.36,0-2.25-.13-12.91-.77a72.77,72.77,0,0,1-10.2-1.09c-.9-.18-1.79-.4-2.68-.64-5-1.34-9.89-3.34-15.06-3.63-1.5-.09-3,0-4.53,0h-.42a22.53,22.53,0,0,1-3-.2c-1.64-.24-3.25-.76-4.92-.84-4.28-.22-8.06,2.35-11.71,4.69l-1,.62a45,45,0,0,1-8.28,4.12H294.27a5.72,5.72,0,0,1-.81-.75,6.23,6.23,0,0,1-.78-1.07c-.05-.09-.1-.18-.14-.27a9.12,9.12,0,0,1,0-7.71,15.09,15.09,0,0,1,2.53-3.8,35,35,0,0,1,3.66-3.44c6.74-5.62,14.49-10.36,23.11-12,.6-.11,1.21-.21,1.81-.29a80.26,80.26,0,0,1,13-.43l4.07.08,17.05.35h.47c6.85.13,14.05.18,20.24-2.55a23.77,23.77,0,0,0,2.3-1.18,4.33,4.33,0,0,0,1.59-1.38,4.77,4.77,0,0,0,.47-2.6l-.06-9-.12-17.35h0q0-6.39-.08-12.77a8.77,8.77,0,0,1,2.45-7.27c2.49-3.13,8.56-14.18,12.86-14.36a3.46,3.46,0,0,1,2.15.6h0c3.66,2.44,3.68,11.69,3.77,14.81q.15,5.17.45,10.33a350.86,350.86,0,0,0,5,42C410,673.73,410.8,677.91,409.84,681.91Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M326.23,503.83c-2.54.38-5.35,1.06-6.73,3.22-1.08,1.68-1,3.81-1.37,5.77a12.8,12.8,0,0,1-4.92,7.87c-2.1,1.55-4.64,2.42-6.81,3.87s-4.09,3.82-3.8,6.42c.25,2.27,2.06,4,2.91,6.14,1.57,3.9-.28,8.25-2,12.09s-3.34,8.36-1.37,12.07c2.09,3.91,7.48,5.39,9,9.54,1.89,5-3,10.33-2.37,15.66.54,4.38,4.86,7.51,9.23,8.15,2.09.3,4.41.09,6-1.3s2.09-3.66,2.16-5.77c.27-8.14-4.36-15.61-5.71-23.65-.44-2.65-.5-5.49.73-7.88.78-1.51,2-2.75,2.68-4.32,1.35-3.27-.18-7.22,1.27-10.45a27.36,27.36,0,0,1,2.83-4c.93-1.35,1.55-3.14.82-4.61a16.15,16.15,0,0,1,5.95,6.76c1.89-.38,1.84-4.44,3.69-3.86.52.17.82.72,1.16,1.15a5.21,5.21,0,0,0,5.54,1.46,10.89,10.89,0,0,0,4.88-3.51l3.16,3.92a3.61,3.61,0,0,1,3.47-2.2,8.34,8.34,0,0,1,4.1,1.41c6,3.59,10.5,10.94,8.2,17.54-1,2.82-3,5.13-4.34,7.81s-1.68,6.28.46,8.36c.44.44,1,.78,1.38,1.26,1.57,1.85.58,4.67,1.05,7,.83,4.29,5.89,6,10.15,7,3,.68,6.57,1.19,8.67-1,2.3-2.4,1.27-6.33-.12-9.35s-3-6.51-1.51-9.47,5.86-4,7.43-7.09c2-3.93-1.53-8.24-2.94-12.42-1.93-5.72.22-12.14-1.36-18a25.12,25.12,0,0,0-4.42-8.12c-4.67-6.28-10.27-12.05-17.21-15.69-6.56-3.44-13.17-4-20.4-3.13C339.28,503.3,332.74,502.86,326.23,503.83Z"
              transform="translate(-7.95 -78.25)"
              fill="#3c354c"
            />
            <path
              d="M383.23,636.74a2.42,2.42,0,0,1-1.15-1.59q-3.33-9.36-6.24-18.85a7.33,7.33,0,0,1-.47-3.51,6.82,6.82,0,0,1,2.68-3.65A40,40,0,0,1,389,602.72c2.88-1.13,7.13-3.14,10-1.31,3.56,2.27-.24,8-1.54,11a114.08,114.08,0,0,1-6,12C390.78,625.61,384.14,637.1,383.23,636.74Z"
              transform="translate(-7.95 -78.25)"
              fill="#f2f2f2"
            />
            <path
              d="M388.94,697.66A6,6,0,0,1,388,699a3.06,3.06,0,0,1-.36.36,4.19,4.19,0,0,1-.45.39H369.8a45,45,0,0,1-8.28-4.12l-1-.62c-3.65-2.34-7.43-4.91-11.71-4.69-1.67.08-3.28.6-4.92.84a22.53,22.53,0,0,1-3,.2h-.42c-1.51,0-3-.07-4.53,0-5.17.29-10.05,2.29-15.06,3.63-.89.24-1.78.46-2.68.64a72.77,72.77,0,0,1-10.2,1.09l-15.16.9h-.36c-4.53.26-9.44.32-13-2.47a18.92,18.92,0,0,1-4.24-5.42,28.16,28.16,0,0,1-3.67-7.86c-1-4-.16-8.18.57-12.23a352.25,352.25,0,0,0,5.43-52.34c.09-3.13.11-12.41,3.79-14.82a3.19,3.19,0,0,1,1.39-.54h0a3.56,3.56,0,0,1,.74,0c4.3.18,10.37,11.23,12.86,14.36a8.77,8.77,0,0,1,2.45,7.27q0,6.16-.08,12.34c0,.19,0,.38,0,.56q-.07,13.14-.17,26.27a4.77,4.77,0,0,0,.47,2.6,2.86,2.86,0,0,0,.52.63,6.63,6.63,0,0,0,1.07.75c6.65,3.92,14.82,3.88,22.54,3.73h.47l17.05-.35,4.07-.08a80.26,80.26,0,0,1,13,.43c.6.08,1.21.18,1.81.29A47.08,47.08,0,0,1,377.85,679q2.5,1.77,4.86,3.74c2.46,2,4.88,4.32,6.19,7.24A9.12,9.12,0,0,1,388.94,697.66Z"
              transform="translate(-7.95 -78.25)"
              fill="#a0616a"
            />
            <path
              d="M299.28,636.74a2.45,2.45,0,0,0,1.15-1.59q3.33-9.36,6.24-18.85a7.45,7.45,0,0,0,.46-3.51,6.82,6.82,0,0,0-2.68-3.65,39.74,39.74,0,0,0-10.94-6.42c-2.88-1.13-7.12-3.14-10-1.31-3.56,2.27.23,8,1.54,11a112.09,112.09,0,0,0,6,12C291.73,625.61,298.37,637.1,299.28,636.74Z"
              transform="translate(-7.95 -78.25)"
              fill="#f2f2f2"
            />
            <path
              d="M840.33,523.23c5.95-1.45,10.57,8.4,16.56,7.23,3.29-.64,5.83-4.54,9.16-4.25,3.79.33,5.41,5.51,7.35,9.3,3.37,6.56,10.18,10.53,16.74,9.74,2.06-2.72,1.67-6.9.62-10.3s-2.65-6.7-2.69-10.32c-.05-4.79,2.58-10.09.2-14-1.83-3-5.57-3.24-8.32-5.09-2.15-1.44-3.66-3.85-5.46-5.82a18.05,18.05,0,0,0-11.13-5.85c-3.54-.4-7.1.36-10.6,1.12l-16.36,3.54a4.55,4.55,0,0,0-2.55,1.17,8.81,8.81,0,0,0-1.32,3.35c-1.55,5.08-6.41,7.46-10.38,10.28s-7.74,8.4-5.55,13.15c1.24,2.69,4.16,4.35,4.47,7.37.27,2.7-1.68,4.91-3.27,6.91-6.75,8.46,8.38,12.86,12,7.12C833.83,541.56,831.82,525.31,840.33,523.23Z"
              transform="translate(-7.95 -78.25)"
              fill="#3c354c"
            />
            <path
              d="M831.68,576.44c-1.42,1.85-3.27,3.39-4.41,5.43a12.49,12.49,0,0,0-.66,9.37,35.4,35.4,0,0,0,4.27,8.6,50,50,0,0,0,7.5,10,18.25,18.25,0,0,0,11,5.46c4.45.33,8.75-1.51,12.78-3.44a14,14,0,0,0,4.61-3,14.29,14.29,0,0,0,2.24-4.07l3.47-8.31a22.89,22.89,0,0,0,2-6.38c.36-3.45-.84-6.86-2-10.13l-6.35-17.47a5.9,5.9,0,0,0-1.52-2.65,5.73,5.73,0,0,0-2.34-1,67.92,67.92,0,0,0-12.27-2c-3.08-.21-10.07-1.3-12.76.44-2.47,1.61-1.44,5.71-1.73,8.36A21.17,21.17,0,0,1,831.68,576.44Z"
              transform="translate(-7.95 -78.25)"
              fill="#a0616a"
            />
            <path
              d="M831.68,576.44c-1.42,1.85-3.27,3.39-4.41,5.43a12.49,12.49,0,0,0-.66,9.37,35.4,35.4,0,0,0,4.27,8.6,50,50,0,0,0,7.5,10,18.25,18.25,0,0,0,11,5.46c4.45.33,8.75-1.51,12.78-3.44a14,14,0,0,0,4.61-3,14.29,14.29,0,0,0,2.24-4.07l3.47-8.31a22.89,22.89,0,0,0,2-6.38c.36-3.45-.84-6.86-2-10.13l-6.35-17.47a5.9,5.9,0,0,0-1.52-2.65,5.73,5.73,0,0,0-2.34-1,67.92,67.92,0,0,0-12.27-2c-3.08-.21-10.07-1.3-12.76.44-2.47,1.61-1.44,5.71-1.73,8.36A21.17,21.17,0,0,1,831.68,576.44Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <circle cx="844.51" cy="466.38" r="27.7" fill="#a0616a" />
            <path
              d="M913.84,613.8c.06,7.64-2.87,15-5.9,22s-6.88,13.91-9.84,21.1c-.24.58-.47,1.17-.7,1.76q-7.64,19.74-13.52,40.09l-.29,1h-85.9c3.92-15,7.28-30-2.12-40.35-.29-.32-.58-.65-.86-1-6.15-7.41-8.91-17.52-16.22-23.82-1.68-1.45-3.63-2.73-4.67-4.7a8.54,8.54,0,0,1-.88-3.9,26.48,26.48,0,0,1,.22-3.56c.72-6.5,1.65-13.32,5.57-18.56a27.42,27.42,0,0,1,6.35-5.9,50.67,50.67,0,0,1,17.71-7.91c7.16-1.64,15.06-1.88,20.9-6.35a24.71,24.71,0,0,1,4-3l.4-.17a4.16,4.16,0,0,1,4.31.46,5.93,5.93,0,0,1,1.44,3q1.59,5.82,3.19,11.64a11.89,11.89,0,0,0,2.41,5.24c2.83,2.94,8.24,2.59,10.44,6,1.32,2.07,4.79-.34,6.3-2.26a84.8,84.8,0,0,0,9.45-14.94,24,24,0,0,1,3.5-5.83,7.92,7.92,0,0,1,3.86-2.34,5.2,5.2,0,0,1,2.22-.06c2.16.44,3.74,2.22,5.21,3.86a117,117,0,0,0,30.74,24.45,5.09,5.09,0,0,1,2.25,1.86,3.85,3.85,0,0,1,.38,1.61C913.83,613.43,913.84,613.62,913.84,613.8Z"
              transform="translate(-7.95 -78.25)"
              fill="#3c354c"
            />
            <path
              d="M843.32,521.82c4.63-1,8.22,5.65,12.88,4.86,2.56-.42,4.54-3,7.12-2.85,2.95.22,4.21,3.7,5.72,6.24a13.83,13.83,0,0,0,13,6.55c1.6-1.83,1.3-4.63.48-6.92s-2.07-4.51-2.1-6.93c0-3.23,2-6.79.16-9.42-1.42-2-4.33-2.18-6.47-3.42-1.67-1-2.84-2.59-4.25-3.91a14.79,14.79,0,0,0-8.65-3.93,29.42,29.42,0,0,0-8.24.75l-12.72,2.38a3.76,3.76,0,0,0-2,.78,5.51,5.51,0,0,0-1,2.25c-1.21,3.42-5,5-8.07,6.91s-6,5.65-4.32,8.84c1,1.81,3.23,2.92,3.47,5,.22,1.81-1.3,3.3-2.54,4.64-5.24,5.68,6.52,8.64,9.35,4.78C838.27,534.14,836.7,523.22,843.32,521.82Z"
              transform="translate(-7.95 -78.25)"
              fill="#3c354c"
            />
            <path
              d="M926.84,699.75H903.45c.38-9.58-3.52-19.31-4-29.08-.18-3.67.13-7.4-.61-11a24.1,24.1,0,0,0-.75-2.77c-.59-1.85-1.31-3.67-1.87-5.53-1.86-6.21-1.79-12.81-1.7-19.29q.16-10.73.34-21.44c0-1.86-.55-4.6,1.14-5.38,3.81-1.76,7.77,1.73,11.27,4,2.1,1.4,4.5,2.5,6.54,4a12.22,12.22,0,0,1,3.11,3.1,17.38,17.38,0,0,1,2.07,5.39q4.25,16.23,7.4,32.73a106.24,106.24,0,0,1,2,14.5C929,679.22,926.87,689.55,926.84,699.75Z"
              transform="translate(-7.95 -78.25)"
              fill="#3c354c"
            />
            <path
              d="M781.56,688.61c-1,2.44-2.08,5-1.93,7.66a11.91,11.91,0,0,0,.8,3.48H759.24a78.17,78.17,0,0,1-2.4-11c-1-7.24-.45-14.61.49-21.87A79.83,79.83,0,0,1,761,650.31c2.46-6.89,6.35-13.13,9.66-19.61.78-1.51,1.49-3.21,2.32-4.71,1.78-3.29,4.08-5.71,8.66-3.5,11.39,5.49,16.28,24.72,13.11,35.92a.29.29,0,0,1,0,.09,55.42,55.42,0,0,1-3.38,8.27Q786.21,677.59,781.56,688.61Z"
              transform="translate(-7.95 -78.25)"
              fill="#3c354c"
            />
            <path
              d="M595.94,509.23a10.12,10.12,0,0,1,5.35,4.54c.91,1.89.88,4.1,1.5,6.11,1.31,4.23,5.25,7,7.7,10.7,3.32,5,3.71,11.37,3.48,17.37s-1,12.12.5,17.95c.71,2.84,1.92,5.54,2.41,8.43.59,3.5.1,7.16,1,10.6.79,3.13,2.64,5.87,4.46,8.53l7.78,11.37a89.83,89.83,0,0,1-10.27-3.09,18.42,18.42,0,0,0,5.55,8.39l-5.62-6.8a16.12,16.12,0,0,0-4.19-4c-2.06-1.17-4.5-1.35-6.82-1.83-4.45-.9-8.91-3.18-11.09-7.19-2.91-5.34-1-12.05-2.67-17.91-1.19-4.28-4.13-7.81-6.15-11.75-4.59-8.93-4.31-19.46-5.75-29.4-.62-4.22-1.56-8.41-1.58-12.68,0-3.15.31-9.13,3.61-10.74C588,506.48,593.28,508.1,595.94,509.23Z"
              transform="translate(-7.95 -78.25)"
              fill="#3f3d56"
            />
            <path
              d="M599.37,580.76c.47,5.22,1.56,11.38,6.32,13.57,2.69,1.24,5.82.78,8.74,1.26,5.51.89,10,5.13,12.6,10.1s3.43,10.61,4,16.17c.75,6.95,1,14.5-2.83,20.36-3.09,4.75-8.43,7.64-13.9,9.11a38.79,38.79,0,0,1-32.37-6c-4.53-3.29-8.27-7.53-11.91-11.77-7.93-9.23-15.91-19.35-17.54-31.41-.19-1.37-.17-3,1-3.84a4.19,4.19,0,0,1,2.55-.51l7.6.14c1.93,0,4.11,0,5.42-1.45s1.23-3.27,1.18-5q-.29-11-.58-22.05a3.17,3.17,0,0,1,.5-2.23,2.94,2.94,0,0,1,1.75-.75c4.19-.71,8.57,0,12.67-1.14,3.9-1.07,10-5.55,12.89-.95C599.88,568.22,599,576.32,599.37,580.76Z"
              transform="translate(-7.95 -78.25)"
              fill="#ffc1c7"
            />
            <path
              d="M599.37,580.76c.47,5.22,1.56,11.38,6.32,13.57,2.69,1.24,5.82.78,8.74,1.26,5.51.89,10,5.13,12.6,10.1s3.43,10.61,4,16.17c.75,6.95,1,14.5-2.83,20.36-3.09,4.75-8.43,7.64-13.9,9.11a38.79,38.79,0,0,1-32.37-6c-4.53-3.29-8.27-7.53-11.91-11.77-7.93-9.23-15.91-19.35-17.54-31.41-.19-1.37-.17-3,1-3.84a4.19,4.19,0,0,1,2.55-.51l7.6.14c1.93,0,4.11,0,5.42-1.45s1.23-3.27,1.18-5q-.29-11-.58-22.05a3.17,3.17,0,0,1,.5-2.23,2.94,2.94,0,0,1,1.75-.75c4.19-.71,8.57,0,12.67-1.14,3.9-1.07,10-5.55,12.89-.95C599.88,568.22,599,576.32,599.37,580.76Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <circle cx="572.28" cy="472.03" r="29.05" fill="#ffc1c7" />
            <path
              d="M644.89,674.68a27.08,27.08,0,0,1-.83,3.51,82.44,82.44,0,0,1-3.2,7.89c-.46,1.07-.89,2.14-1.26,3.24-.29.86-.54,1.74-.76,2.62s-.48,2.07-.66,3.12c-.27,1.55-.47,3.12-.63,4.69H561.74a47.26,47.26,0,0,0-.43-11.5A75.65,75.65,0,0,0,556.63,673c-4.83-12.38-10.23-25-13.2-37.91,0,0,0,0,0-.05a75.34,75.34,0,0,1-1.84-25.64c.06-.5.13-1,.2-1.52a39.16,39.16,0,0,1,.73-3.86,21.27,21.27,0,0,1,4.83-9.78c3.4-3.66,9.15-5.47,13.56-3.13,2.66,1.41,4.31,3.91,5.63,6.68.84,1.76,1.55,3.62,2.29,5.39a55,55,0,0,0,11.48,17.15c.93,1,1.91,1.89,2.92,2.77s1.89,1.62,2.88,2.38c3.21,2.47,7.08,5.6,11.27,5.71,2.43.07,4.91,0,7.42,0,2.2,0,4.42-.09,6.61,0,4.69.09,10-1.24,12.27-5.35,1.55-2.81,1.29-6.24,1-9.44-.23-2.5-.46-5-.7-7.51,0-.13,0-.26,0-.39-.16-1.81-.33-3.6-.5-5.41h0c-.08-.87-.16-1.75-.25-2.62v0l-.18-1.94q1.25-.14,2.52-.24c3.79-.3,7.66-.23,10.92,1.62,3.1,1.75,5,4.76,6.22,8.17a32.82,32.82,0,0,1,1.56,7.5c1.12,11.35-.69,22.8-.07,34.18C644.6,658,646.34,666.55,644.89,674.68Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M662.2,699.75H639.27c-.19-2.6-.34-5.2-.43-7.81-.08-1.8-.14-3.61-.17-5.41q-.15-7.28.12-14.52a32.75,32.75,0,0,0,14.75,4.21,28.25,28.25,0,0,1,5,7.93,38.47,38.47,0,0,1,1.71,4.91.14.14,0,0,1,0,.07A65.63,65.63,0,0,1,662.2,699.75Z"
              transform="translate(-7.95 -78.25)"
              fill="#ffc1c7"
            />
            <path
              d="M660.19,684.12a106.7,106.7,0,0,0-25.7,3.4c-1.11-5.48-.57-11.14,0-16.7l3.71-38.21c.27-2.83-.25-28.81,5.23-24.22,2,1.69,4.56,16.88,5.19,19.32.95,3.69,1.7,7.42,2.37,11.16,1.37,7.68,2.3,15.42,3.63,23.11C655,664.2,658.21,684.14,660.19,684.12Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M591.3,513.34a5,5,0,0,0-.6-2.61,4.34,4.34,0,0,0-3.11-1.64c-4.19-.65-8.79,1-12.58-.88-2-1-3.51-3-5.51-4.11-4.72-2.67-10.68,0-14.86,3.46a43.38,43.38,0,0,0-13.93,21.22c-1.86,6.42-2.61,13.93-7.93,18-2.2,1.68-5,2.61-6.65,4.85-1.24,1.72-1.53,3.93-1.76,6-.55,4.88-1,9.88.27,14.62,1,3.53,2.85,6.73,4,10.2a27.08,27.08,0,0,1-7.38,28.18,8.78,8.78,0,0,0,6.5,1.13,5.57,5.57,0,0,1-.94,2.87c6.8-.22,12.71-6.84,19.36-5.39,5.08,1.1,7.91,6.34,11.7,9.9,4.88,4.59,12.46,6.51,18.59,3.79s9.85-10.46,7.25-16.64c-3-7-12.09-9.81-15.26-16.76-2.45-5.39-.63-11.67-1.16-17.56-.45-5.06-2.63-9.77-4-14.66s-1.8-10.48,1-14.74c2.94-4.52,8.57-6.28,13.69-8C589.52,530.85,591.74,525,591.3,513.34Z"
              transform="translate(-7.95 -78.25)"
              fill="#3f3d56"
            />
            <path
              d="M584.16,617.78c.83-4,1.65-8.37.19-12.24-2.72-7.22-11.61-9.47-17.76-14.12a24,24,0,0,1-7.9-10.53c-1.12-2.93-1.27-7,1.48-8.48a6.67,6.67,0,0,1,3.43-.6c9.58.22,18.36,5.43,25.71,11.59,4.27,3.59,8.33,7.7,10.46,12.85,1.51,3.65,2,7.63,2.43,11.55l1.5,13a203.79,203.79,0,0,1,1.73,22.47,99.15,99.15,0,0,1-.81,12.89c-.38,3-1,6.16-2.73,8.65-3.32,4.63-9.7,5.67-15.4,5.83a26.6,26.6,0,0,1-6.43-.41c-9.47-2.06-16.65-15.32-9.49-23.51,3-3.48,7.62-3.57,9.35-8.34C582.24,632.06,582.8,624.41,584.16,617.78Z"
              transform="translate(-7.95 -78.25)"
              fill="#ffc1c7"
            />
            <path
              d="M576.47,620.06l7.47,12.21a5.58,5.58,0,0,1,.91,2.11c.21,1.59-1,3-1.92,4.29-6.44,8.8-4.8,20.9-2.86,31.63a57.41,57.41,0,0,1-39.46-46.47c-.94-6.39-2.46-16.91,3.21-21.07C557.48,592.74,570.06,609.6,576.47,620.06Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M614.43,595.59c-2.92-.48-6,0-8.74-1.26-4.76-2.19-5.85-8.35-6.32-13.57,0-.48-.07-1-.09-1.57a43.43,43.43,0,0,1,5.53-4.81,27.18,27.18,0,0,1,5.65-2.49l5.28-1.86a30.25,30.25,0,0,1,1.14,4.3c.59,3.5.1,7.16,1,10.6.79,3.13,2.64,5.87,4.46,8.53l7.78,11.37c-1.41-.33-2.81-.71-4.2-1.11C623.23,599.64,619.2,596.36,614.43,595.59Z"
              transform="translate(-7.95 -78.25)"
              fill="#3f3d56"
            />
            <path
              d="M114.84,794.92c3-5.51-.4-12.27-4.29-17.18s-8.61-10-8.51-16.29c.15-9,9.7-14.31,17.33-19.09a84,84,0,0,0,15.56-12.51,22.8,22.8,0,0,0,4.78-6.4c1.58-3.52,1.54-7.52,1.44-11.37q-.51-19.26-1.91-38.49"
              transform="translate(-7.95 -78.25)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="4"
            />
            <path
              d="M153.75,672.89a14,14,0,0,0-7-11.5l-3.14,6.22.1-7.53a14.22,14.22,0,0,0-4.63-.56,14,14,0,1,0,14.68,13.37Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M128.72,767.88a14,14,0,1,1,.68-11.3l-8.77,7.13,9.65-2.23A14,14,0,0,1,128.72,767.88Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M121.79,740.63a14,14,0,0,1-4.45-27.53l-.08,5.78,3.18-6.29h0A14,14,0,0,1,135.15,726a13.84,13.84,0,0,1-.6,4.79A14,14,0,0,1,121.79,740.63Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M155.86,718a14,14,0,1,1,6.21-26.27l-2.48,6.8,5.1-4.9a14,14,0,0,1,4.53,9.69,13.79,13.79,0,0,1-.35,3.87A14,14,0,0,1,155.86,718Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M151.86,676.63c-3.24.35-6.39,1.36-9.64,1.56s-6.82-.57-8.88-3.1c-1.1-1.36-1.66-3.08-2.59-4.57a10,10,0,0,0-3.54-3.33,14,14,0,1,0,26.24,9.32Q152.65,676.54,151.86,676.63Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M155.86,718a14,14,0,0,1-13.35-20,10.37,10.37,0,0,1,2.82,2.82c1,1.51,1.61,3.26,2.78,4.64,2.19,2.57,5.92,3.41,9.31,3.26s6.66-1.12,10-1.43c.47,0,.94-.07,1.42-.08A14,14,0,0,1,155.86,718Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M121.79,740.63a14,14,0,0,1-13.46-19.76,11.48,11.48,0,0,1,3,2.85c1.09,1.54,1.77,3.32,3,4.74,2.37,2.63,6.35,3.56,9.93,3.48s6.83-.93,10.28-1.2A14,14,0,0,1,121.79,740.63Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M128.72,767.88a14,14,0,0,1-25.59-11.45,13.84,13.84,0,0,1,3.08,2.75c1.34,1.62,2.22,3.47,3.76,5,2.87,2.82,7.5,4,11.63,4.09A60,60,0,0,0,128.72,767.88Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M93.67,788.57s11.08-.34,14.42-2.72,17-5.21,17.86-1.4,16.65,19,4.15,19.06-29.06-1.94-32.4-4S93.67,788.57,93.67,788.57Z"
              transform="translate(-7.95 -78.25)"
              fill="#656380"
            />
            <path
              d="M130.32,802.19c-12.51.1-29.06-2-32.39-4-2.54-1.55-3.55-7.09-3.89-9.65h-.37s.7,8.94,4,11,19.89,4.07,32.4,4c3.61,0,4.85-1.31,4.78-3.21C134.38,801.45,133,802.16,130.32,802.19Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.2"
            />
            <path
              d="M1040.59,781.3c5.29-9.8-.71-21.81-7.62-30.56s-15.32-17.84-15.14-29c.26-16,17.25-25.47,30.82-33.95a149.88,149.88,0,0,0,27.68-22.26c3.34-3.4,6.56-7,8.51-11.38,2.81-6.26,2.73-13.38,2.55-20.24q-.89-34.26-3.39-68.46"
              transform="translate(-7.95 -78.25)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="4"
            />
            <path
              d="M1109.81,564.23a24.93,24.93,0,0,0-12.46-20.46l-5.59,11.06.17-13.39a25,25,0,1,0,17.88,22.79Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M1065.29,733.21a25,25,0,1,1,1.2-20.1L1050.9,725.8l17.15-4A24.76,24.76,0,0,1,1065.29,733.21Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M1053,684.73a25,25,0,0,1-7.92-49l-.13,10.29,5.65-11.19h.07a25,25,0,1,1,2.33,49.88Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M1113.57,644.4a25,25,0,1,1,11-46.72l-4.41,12.09,9.08-8.71a24.84,24.84,0,0,1,8.07,17.23,24.49,24.49,0,0,1-.64,6.88A25,25,0,0,1,1113.57,644.4Z"
              transform="translate(-7.95 -78.25)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M1106.45,570.88c-5.76.63-11.36,2.42-17.15,2.78s-12.13-1-15.79-5.52c-2-2.42-3-5.48-4.62-8.13a17.7,17.7,0,0,0-6.28-5.91,25,25,0,1,0,46.67,16.57C1108.33,570.71,1107.39,570.78,1106.45,570.88Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M1113.57,644.4a25,25,0,0,1-23.75-35.61,18.45,18.45,0,0,1,5,5c1.78,2.69,2.85,5.79,5,8.25,3.88,4.58,10.53,6.07,16.55,5.8s11.84-2,17.85-2.54c.83-.07,1.67-.13,2.51-.15A25,25,0,0,1,1113.57,644.4Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M1053,684.73a25,25,0,0,1-24-35.15,20.24,20.24,0,0,1,5.27,5.08c1.94,2.74,3.15,5.89,5.42,8.41,4.22,4.69,11.3,6.35,17.68,6.2,6.18-.14,12.13-1.66,18.28-2.13A25,25,0,0,1,1053,684.73Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M1065.29,733.21a25,25,0,0,1-45.52-20.37,25,25,0,0,1,5.48,4.88c2.37,2.9,3.94,6.18,6.68,8.88,5.11,5,13.35,7.07,20.68,7.26A108.65,108.65,0,0,0,1065.29,733.21Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.1"
            />
            <path
              d="M1002.94,770s19.7-.61,25.64-4.84,30.31-9.28,31.79-2.5,29.61,33.74,7.36,33.91-51.69-3.46-57.62-7.07S1002.94,770,1002.94,770Z"
              transform="translate(-7.95 -78.25)"
              fill="#656380"
            />
            <path
              d="M1068.13,794.23c-22.25.18-51.69-3.46-57.62-7.07-4.51-2.75-6.31-12.62-6.92-17.17l-.65,0s1.24,15.89,7.17,19.5,35.38,7.25,57.62,7.07c6.43-.05,8.64-2.33,8.52-5.72C1075.36,792.92,1072.91,794.2,1068.13,794.23Z"
              transform="translate(-7.95 -78.25)"
              opacity="0.2"
            />
          </svg>
        </div>
        <div class="col-md-5 m-2">
          <div
            style="margin-top:10%!important;width:90%;margin:0 auto;"
            class="text-section"
          >
            <h1 style="text-align: left!important ;" class="text-center">
              Hire <strong class="primary-color">Freelancers</strong> and work
              with them on your Dream's projects!
            </h1>
            <p
              style="text-align: left!important ;font-weight:100"
              class="text-center text-dark"
            >
              {{ landing_page_1 }}
            </p>
            <router-link
              to="/projects"
              class="btn float-left primary text-white btn-md"
              >Browse projects</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <!-------------------------------------------------------------->
    <!--<div class="container landing-page-4 margin-between-sections"></div>-->

    <!-------------------------------------------------------------->
    <div class="container landing-page-2 margin-between-sections">
      <div class="row m-2 justify-content-center">
        <div class="col-md-5 m-2">
          <div
            style="margin-top:12%!important;width:90%;margin:0 auto;"
            class="text-section"
          >
            <h1 style="text-align: left!important ;" class="text-center">
              Explore our <strong class="graphql-color">GraphQL API!</strong>
            </h1>
            <p
              style="text-align: left!important;font-weight:100"
              class="text-center text-dark"
            >
              {{ landing_page_2 }}
            </p>
            <router-link
              to="/docs"
              class="btn float-left primary text-white btn-md"
              >Visit Docs</router-link
            >
          </div>
        </div>
        <div class="col-md-5 svg-section m-2">
          <svg
            id="7d8641e0-c257-4791-b312-86d1704443b9"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="100%"
            height="100%"
            viewBox="0 0 1080.96 836.7"
          >
            <defs>
              <linearGradient
                id="125bba2f-f569-40b7-bd66-d57fb0c1ec70"
                x1="522.67"
                y1="796.03"
                x2="522.67"
                y2="67.32"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stop-color="gray" stop-opacity="0.25" />
                <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
                <stop offset="1" stop-color="gray" stop-opacity="0.1" />
              </linearGradient>
              <linearGradient
                id="56fd5fc2-5801-467f-a895-372693779337"
                x1="950.39"
                y1="837.64"
                x2="950.39"
                y2="177.91"
                xlink:href="#125bba2f-f569-40b7-bd66-d57fb0c1ec70"
              />
            </defs>
            <title>report</title>
            <path
              d="M293.94,32.28C259.18,31,222.87,30.1,191.44,45s-55.73,51-45.19,84.19c3.44,10.82,10.14,20.25,15.79,30.1,28.25,49.26,29.56,112.93,3.37,163.32-20.16,38.79-54.33,68.31-78.93,104.45S47.9,513.29,72.1,549.7c16.57,24.93,47.32,37.06,77.11,40s59.75-1.69,89.67-2.88a386.25,386.25,0,0,1,169.58,32.07c73.49,32.22,136.8,87.34,214.18,108.61,9.29,2.55,19,4.61,28.5,2.88,16.85-3.07,29.1-17,42.29-28,42.11-34.87,100.41-41.38,155.07-43s111.59-.37,161-23.84c43.14-20.49,76.35-58.61,97-101.67s29.62-90.91,33-138.56c2-28.36,1.93-57.64-8.22-84.19-11.41-29.85-34.55-53.62-58.82-74.4-25.36-21.72-53-41.4-84.31-53.12-37.4-14-78-16-117.82-19.32a1618.5,1618.5,0,0,1-242.36-38.92C552.34,107.28,469.3,87.53,400.42,50.7,365.85,32.21,332.91,33.68,293.94,32.28Z"
              transform="translate(-59.52 -31.65)"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.1"
            />
            <g opacity="0.1">
              <path
                d="M773.4,661.32s3.54-49.61,31.46-76.66a75.33,75.33,0,0,0,22.26-42.15,127.38,127.38,0,0,0,1.5-23.13"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M846.11,502.23c-2.05,5.48-17.9,17.66-17.9,17.66s-4-19.59-1.93-25.07a10.58,10.58,0,0,1,19.83,7.41Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M851.17,538.7c-4.7,3.48-24.62,5.09-24.62,5.09s7.3-18.61,12-22.1a10.59,10.59,0,0,1,12.62,17Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M831.08,590.27c-5.82.64-23.83-8-23.83-8s15.7-12.38,21.51-13a10.58,10.58,0,0,1,2.32,21Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M807.09,625.87c-5.62,1.61-24.84-3.89-24.84-3.89s13.38-14.85,19-16.46a10.59,10.59,0,1,1,5.84,20.35Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M805.33,537.07c2.5,5.28,19.32,16.07,19.32,16.07s2.32-19.85-.19-25.14a10.59,10.59,0,0,0-19.13,9.07Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M777.8,579.06c4,4.29,23.25,9.56,23.25,9.56s-3.73-19.64-7.7-23.94a10.59,10.59,0,0,0-15.55,14.38Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M756.65,623.54c3.18,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,0,0-17.75,11.54Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M846.11,502.23c-2.05,5.48-17.9,17.66-17.9,17.66s-4-19.59-1.93-25.07a10.58,10.58,0,0,1,19.83,7.41Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M851.17,538.7c-4.7,3.48-24.62,5.09-24.62,5.09s7.3-18.61,12-22.1a10.59,10.59,0,0,1,12.62,17Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M831.08,590.27c-5.82.64-23.83-8-23.83-8s15.7-12.38,21.51-13a10.58,10.58,0,0,1,2.32,21Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M807.09,625.87c-5.62,1.61-24.84-3.89-24.84-3.89s13.38-14.85,19-16.46a10.59,10.59,0,1,1,5.84,20.35Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M805.33,537.07c2.5,5.28,19.32,16.07,19.32,16.07s2.32-19.85-.19-25.14a10.59,10.59,0,0,0-19.13,9.07Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M777.8,579.06c4,4.29,23.25,9.56,23.25,9.56s-3.73-19.64-7.7-23.94a10.59,10.59,0,0,0-15.55,14.38Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M756.65,623.54c3.18,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,0,0-17.75,11.54Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.1">
              <path
                d="M783.2,473.54s3.54-49.61,31.46-76.66a75.4,75.4,0,0,0,22.26-42.15,125.67,125.67,0,0,0,1.5-23.13"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M855.91,314.45c-2,5.47-17.89,17.65-17.89,17.65s-4-19.59-1.94-25.06a10.58,10.58,0,1,1,19.83,7.41Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M861,350.91c-4.69,3.49-24.62,5.09-24.62,5.09s7.3-18.6,12-22.09a10.59,10.59,0,1,1,12.62,17Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M840.88,402.49c-5.81.64-23.82-8-23.82-8s15.7-12.37,21.51-13a10.59,10.59,0,1,1,2.31,21.05Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M816.89,438.09c-5.62,1.61-24.84-3.89-24.84-3.89s13.39-14.85,19-16.47a10.59,10.59,0,0,1,5.83,20.36Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M815.13,349.28c2.5,5.29,19.33,16.08,19.33,16.08s2.31-19.86-.19-25.14a10.59,10.59,0,1,0-19.14,9.06Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M787.6,391.27c4,4.3,23.26,9.56,23.26,9.56s-3.74-19.64-7.71-23.93a10.59,10.59,0,0,0-15.55,14.37Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M766.45,435.76c3.19,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,1,0-17.75,11.54Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M855.91,314.45c-2,5.47-17.89,17.65-17.89,17.65s-4-19.59-1.94-25.06a10.58,10.58,0,1,1,19.83,7.41Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M861,350.91c-4.69,3.49-24.62,5.09-24.62,5.09s7.3-18.6,12-22.09a10.59,10.59,0,1,1,12.62,17Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M840.88,402.49c-5.81.64-23.82-8-23.82-8s15.7-12.37,21.51-13a10.59,10.59,0,1,1,2.31,21.05Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M816.89,438.09c-5.62,1.61-24.84-3.89-24.84-3.89s13.39-14.85,19-16.47a10.59,10.59,0,0,1,5.83,20.36Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M815.13,349.28c2.5,5.29,19.33,16.08,19.33,16.08s2.31-19.86-.19-25.14a10.59,10.59,0,1,0-19.14,9.06Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M787.6,391.27c4,4.3,23.26,9.56,23.26,9.56s-3.74-19.64-7.71-23.93a10.59,10.59,0,0,0-15.55,14.37Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M766.45,435.76c3.19,4.9,21.3,13.35,21.3,13.35s-.36-20-3.55-24.89a10.59,10.59,0,1,0-17.75,11.54Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.1">
              <path
                d="M252.71,538.54S210,513.08,198.37,476a75.26,75.26,0,0,0-27.64-38.83,126.09,126.09,0,0,0-20-11.74"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M143.28,402.07c4,4.29,7.73,23.93,7.73,23.93s-19.29-5.25-23.26-9.54a10.59,10.59,0,0,1,15.53-14.39Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M178.13,414c1,5.76-6.52,24.28-6.52,24.28s-13.34-14.89-14.34-20.65A10.59,10.59,0,1,1,178.13,414Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M215.17,455.08c-2,5.48-17.89,17.67-17.89,17.67s-4-19.59-1.95-25.06a10.59,10.59,0,1,1,19.84,7.39Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M236.18,492.51C235.1,498.26,221.54,513,221.54,513s-7.25-18.63-6.16-24.37a10.58,10.58,0,1,1,20.8,3.93Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M156.07,454.16c5.84.14,23.05-10,23.05-10s-16.7-11-22.55-11.14a10.59,10.59,0,0,0-.5,21.17Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M181.2,497.63c5.62-1.62,19-16.48,19-16.48s-19.22-5.49-24.84-3.87a10.59,10.59,0,0,0,5.85,20.35Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M211.42,536.52c5.82-.64,21.51-13,21.51-13s-18-8.66-23.83-8a10.58,10.58,0,1,0,2.32,21Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M143.28,402.07c4,4.29,7.73,23.93,7.73,23.93s-19.29-5.25-23.26-9.54a10.59,10.59,0,0,1,15.53-14.39Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M178.13,414c1,5.76-6.52,24.28-6.52,24.28s-13.34-14.89-14.34-20.65A10.59,10.59,0,1,1,178.13,414Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M215.17,455.08c-2,5.48-17.89,17.67-17.89,17.67s-4-19.59-1.95-25.06a10.59,10.59,0,1,1,19.84,7.39Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M236.18,492.51C235.1,498.26,221.54,513,221.54,513s-7.25-18.63-6.16-24.37a10.58,10.58,0,1,1,20.8,3.93Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M156.07,454.16c5.84.14,23.05-10,23.05-10s-16.7-11-22.55-11.14a10.59,10.59,0,0,0-.5,21.17Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M181.2,497.63c5.62-1.62,19-16.48,19-16.48s-19.22-5.49-24.84-3.87a10.59,10.59,0,0,0,5.85,20.35Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
              <path
                d="M211.42,536.52c5.82-.64,21.51-13,21.51-13s-18-8.66-23.83-8a10.58,10.58,0,1,0,2.32,21Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <path
              d="M776.25,838c28.71,12.49,63.74,4.89,96.32,5.77,4.45.12,9.18.49,12.75,2.65s5.34,5.65,7.79,8.65c9.13,11.14,27.84,14.72,44.19,12.83s31.34-8.15,46.77-12.91c26.67-8.24,57.15-12,83.46-3,2.41.82,5,1.77,7.54,1.44,5.77-.73,7.49-6.71,11.52-10.12,7.28-6.17,23.1-4.49,26.3-12.62,1.87-4.76-2.44-9.64-7.14-12.89-18-12.44-43.7-14.49-67.23-12.57s-46.66,7.21-70.31,7.23c-29.47,0-57.94-8.12-87.12-11.45-20.21-2.3-42.27-2-61.22,4.77C799.33,813.1,794.81,829.59,776.25,838Z"
              transform="translate(-59.52 -31.65)"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.1"
            />
            <path
              d="M232.93,799.69c49,14.11,108.8,5.52,164.4,6.52,7.61.14,15.67.55,21.78,3s9.11,6.4,13.3,9.78c15.58,12.59,47.51,16.64,75.41,14.5s53.5-9.21,79.84-14.59c45.52-9.31,97.56-13.55,142.46-3.4,4.12.93,8.46,2,12.88,1.63,9.84-.83,12.77-7.58,19.66-11.44,12.43-7,39.42-5.07,44.88-14.25,3.2-5.38-4.16-10.9-12.18-14.57-30.68-14.05-74.58-16.37-114.75-14.2s-79.65,8.14-120,8.17c-50.3,0-98.9-9.17-148.71-12.94-34.5-2.6-72.15-2.28-104.5,5.4C272.33,771.59,264.6,790.22,232.93,799.69Z"
              transform="translate(-59.52 -31.65)"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.1"
            />
            <path
              d="M101.77,834.27c14,8.42,31,3.3,46.86,3.89,2.17.08,4.47.33,6.21,1.78s2.6,3.82,3.79,5.84c4.44,7.51,13.54,9.93,21.49,8.65s15.25-5.49,22.76-8.71c13-5.55,27.81-8.08,40.6-2a6.38,6.38,0,0,0,3.68,1c2.8-.5,3.64-4.53,5.6-6.83,3.54-4.16,11.24-3,12.79-8.51.91-3.21-1.19-6.5-3.47-8.69-8.74-8.39-21.26-9.77-32.71-8.48S206.67,817,195.16,817c-14.33,0-28.18-5.47-42.38-7.72-9.84-1.56-20.57-1.36-29.79,3.22C113,817.5,110.8,828.62,101.77,834.27Z"
              transform="translate(-59.52 -31.65)"
              class="dynamic-svg"
              fill="#6c63ff"
              opacity="0.1"
            />
            <path
              d="M755,67.32H290.38a42.55,42.55,0,0,0-42.62,42.49V753.54A42.55,42.55,0,0,0,290.38,796H755a42.55,42.55,0,0,0,42.62-42.49V109.81A42.55,42.55,0,0,0,755,67.32Z"
              transform="translate(-59.52 -31.65)"
              fill="url(#125bba2f-f569-40b7-bd66-d57fb0c1ec70)"
            />
            <rect
              x="194.79"
              y="44.4"
              width="536.72"
              height="713.44"
              rx="20"
              ry="20"
              fill="#535461"
            />
            <rect
              x="222.06"
              y="111.88"
              width="482.18"
              height="578.47"
              fill="#f6f7f9"
            />
            <circle cx="460.97" cy="77.12" r="6.55" fill="#f6f7f9" />
            <circle cx="460.97" cy="722.93" r="19.64" fill="#f6f7f9" />
            <g opacity="0.2">
              <rect
                x="222.06"
                y="111.88"
                width="482.18"
                height="28.83"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <circle cx="237.14" cy="126.3" r="6.15" fill="#f6f7f9" />
            <circle cx="252.81" cy="126.3" r="6.15" fill="#f6f7f9" />
            <circle cx="268.47" cy="126.3" r="6.15" fill="#f6f7f9" />
            <rect
              x="236.46"
              y="281.93"
              width="449.01"
              height="1.5"
              fill="#dce0ed"
            />
            <rect
              x="236.46"
              y="316.76"
              width="449.01"
              height="1.5"
              fill="#dce0ed"
            />
            <rect
              x="236.46"
              y="351.6"
              width="449.01"
              height="1.5"
              fill="#dce0ed"
            />
            <rect
              x="236.46"
              y="386.43"
              width="449.01"
              height="1.5"
              fill="#dce0ed"
            />
            <rect
              x="236.46"
              y="421.26"
              width="449.01"
              height="1.5"
              fill="#dce0ed"
            />
            <g opacity="0.2">
              <polygon
                points="685.47 422.76 235.91 422.76 235.91 354.26 277.14 374.58 319.81 380.37 357.25 369.08 402.42 334.05 425.14 320.93 441.75 317.73 457.64 318.58 483.77 331.49 519.3 354.12 547.18 357.7 569.28 350.08 616.14 311.71 640.06 303.18 665.09 307.05 685.47 318.82 685.47 422.76"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <path
              d="M373.79,412c-40.49,0-77.9-24.76-78.37-25.08l1.12-1.66c.58.39,58.16,38.48,107.09,19.4,17.84-7,30.54-17.78,42.83-28.25,12.83-10.93,24.94-21.25,41.46-25.73,18.94-5.13,39.64-.49,55.37,12.44,13.45,11.05,40.23,28.79,68.52,23.49,14.42-2.71,26.57-13.24,39.44-24.39,24.67-21.38,50.19-43.49,94.33-11.77l-1.17,1.62c-42.86-30.8-67.76-9.21-91.85,11.66-13.08,11.33-25.43,22-40.38,24.84-29.1,5.46-56.44-12.64-70.16-23.91-15.23-12.51-35.25-17-53.58-12.05-16.08,4.36-28,14.54-40.69,25.32-12.41,10.58-25.24,21.51-43.39,28.59A83.72,83.72,0,0,1,373.79,412Z"
              transform="translate(-59.52 -31.65)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <circle
              cx="452.52"
              cy="317.63"
              r="11.13"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <g opacity="0.2">
              <path
                d="M657.22,202H516.82a2.28,2.28,0,0,0-2.28,2.28v94.95a2.28,2.28,0,0,0,3.94,1.56l24.33-25.95a2.27,2.27,0,0,1,1.66-.72H657.22a2.28,2.28,0,0,0,2.28-2.28V204.26A2.28,2.28,0,0,0,657.22,202Z"
                transform="translate(-59.52 -31.65)"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <rect
              x="487.52"
              y="187.93"
              width="79.95"
              height="10"
              fill="#f6f7f9"
            />
            <rect
              x="487.52"
              y="210.09"
              width="21.95"
              height="10"
              fill="#f6f7f9"
            />
            <g opacity="0.2">
              <rect
                x="274.38"
                y="494.32"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="274.38"
                y="513.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="274.38"
                y="532.98"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="274.38"
                y="552.32"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="274.38"
                y="571.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="274.38"
                y="590.98"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="274.38"
                y="610.32"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="274.38"
                y="629.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="315.71"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="354.38"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="393.05"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="431.71"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="470.38"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="509.05"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="547.71"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="586.38"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="625.05"
                y="639.65"
                width="21.95"
                height="10"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <rect
              x="534.14"
              y="210.09"
              width="33.33"
              height="10"
              class="dynamic-svg"
              fill="#f6f7f9"
            />
            <rect
              x="315.71"
              y="566.98"
              width="21.95"
              height="62.67"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <rect
              x="354.38"
              y="537.98"
              width="21.95"
              height="91.67"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <rect
              x="393.05"
              y="513.65"
              width="21.95"
              height="116"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <rect
              x="431.71"
              y="526.26"
              width="21.95"
              height="103.38"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <rect
              x="470.38"
              y="504.32"
              width="21.95"
              height="125.33"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <g opacity="0.2">
              <rect
                x="509.05"
                y="552.32"
                width="21.95"
                height="77.33"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="547.71"
                y="552.32"
                width="21.95"
                height="77.33"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="586.38"
                y="552.32"
                width="21.95"
                height="77.33"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <g opacity="0.2">
              <rect
                x="625.05"
                y="552.32"
                width="21.95"
                height="77.33"
                class="dynamic-svg"
                fill="#6c63ff"
              />
            </g>
            <path
              d="M1049,304.15c-23.77-13.67-32.75-17.06-32.8-17.08l-.48-.35a19.86,19.86,0,0,1-6-7.57c0-.55,0-1.09,0-1.63v.16c.38-7.24,5.53-13.83,10.42-19.58l12.49-14.7a14.27,14.27,0,0,0,3.22-5.1,11.39,11.39,0,0,0,.34-3.13c0-.43,0-.86,0-1.28-.06-3.65-.17-7.31-.3-11-.12-3.19-.94-7.21-4.13-7.87-1.66-.34-3.85.26-4.73-1.17a2.72,2.72,0,0,1-.21-1.89.8.8,0,0,0,0,.15l0-.18a42.36,42.36,0,0,0,1.19-7.51,10.44,10.44,0,0,0-.52-3.8c-1.85-5.3-8.21-7.47-13.84-8.47s-11.93-1.86-15.46-6.26c-1.09-1.36-1.83-3-3.07-4.23a12.19,12.19,0,0,0-5.75-2.84,32.49,32.49,0,0,0-20.92,1.82c-2.72,1.21-5.45,2.85-8.43,2.67s-5.75-2.33-8.81-2.85c-4.94-.84-9.67,2.79-12.1,7.08a17.29,17.29,0,0,0-2.24,8.36c0,.16,0,.33,0,.49h0a12.19,12.19,0,0,0,3.21,8.53c2.13,2.21,5.31,3.73,6.19,6.64.36,1.18.27,2.46.59,3.66,0,.15.09.3.14.44l-.16.21A37.05,37.05,0,0,0,939,238.75a37.9,37.9,0,0,0,26.63,35.94c0,.37,0,.75,0,1.12,0,4.54-1.29,9.17-5.17,12.58L926.8,301.93s-20.29-2.41-27.61,27.25a50.12,50.12,0,0,0-1.26,15.05c.27,4.47-.35,12.35-5.55,22.54-8.33,16.3-6.43,53.72,10.59,57.43,16.07,3.5,22.36,2,23,1.87l0,.65c-.26,7-2.81,67.59-12.08,74.92-2.56,2-2.08,3.4,0,4.32,0,0,0,.39-.06,1.09-.28,4.43-1.71,21.3-7.91,30.9-7.19,11.11-6.44,75.22-6.44,75.22L894.65,651s3,23.34,0,27.42c-2.7,3.63-6.3,90-7,108.71h-.32a9.09,9.09,0,0,0-7.27,4.43c-4,6.46-17.9,18.39-17.9,18.39-3,4.29-14.19,8.39-20.1,10.33a12.19,12.19,0,0,0-2.28,1,12,12,0,0,0-5.07,5.34,5.78,5.78,0,0,0-.55,4.46c1.52,3.7,32.92,6.29,40.86,2.59,6.25-2.92,31-6.75,41.27-8.25a8.49,8.49,0,0,0,7.35-7.34,4.85,4.85,0,0,0-1-3.68v0c-2-2.44-3-9.09-3.43-13.43a8.87,8.87,0,0,0,2.31-1.37,98.53,98.53,0,0,1,5.67-39.64c7.57-20,9.84-57.07,8-81.15,0,0,23.08-99.3,41.24-108.57h0c.28.35,9.09,11.67,10.21,46.68,1.14,35.57,14,58.91,14,58.91s-5.68,60.4,0,83l-7.43,35.66c-.54-.47-.89-.83-.89-.83s.22,1,.53,2.58l-.16.75.32.08c.84,4.46,2.09,12.23,1.58,16.79-.3,2.59-1,6.15-1.52,9.64-.78,5.49-1,10.81,1.89,12,4.73,1.9,32.54,4.5,37.27-1.61a8.78,8.78,0,0,0,1.38-9.16,9.35,9.35,0,0,0-1.38-2.33s-7.38-12.07-5.3-20.58a6.22,6.22,0,0,0-.88-4.89c.32-4.18,2-23.51,6.37-39.93,4.73-17.83,14.72-56.92,7.37-82.63h0c-.28-1-.6-2-.94-3a110.78,110.78,0,0,1-4.16-43.35,88.3,88.3,0,0,1,0-37.8c4.54-20.75,7.71-41.13,7.71-41.13s2.51-27.41.32-44.22l-.15-1.08,1.2-.27s-6.43-28.53-8.7-46.68c-.54-4.29-1.24-9.72-2-15.52a37.61,37.61,0,0,0,6.17-1.53C1059.6,432.72,1066,369,1066,369V348.8S1072.84,317.86,1049,304.15ZM896.8,796.22c-.63-.32-1-.53-1-.53h0Z"
              transform="translate(-59.52 -31.65)"
              fill="url(#56fd5fc2-5801-467f-a895-372693779337)"
            />
            <path
              d="M1036.67,671.91c8.86,25.48-1.48,66.83-6.28,85.29s-6.28,40.63-6.28,40.63c-18.83,2.95-32.49-.75-32.49-.75l7.75-38c-5.54-22.52,0-82.71,0-82.71s-12.55-23.26-13.66-58.71c-1.09-34.9-9.69-46.17-10-46.52h0c-17.72,9.23-40.25,108.2-40.25,108.2,1.85,24-.37,60.92-7.75,80.86a100.21,100.21,0,0,0-5.54,39.51c-2.58,2.18-6.17,2.55-10.05,1.93C901.61,799.89,889,790.81,889,790.81S893,683,896,678.93s0-27.33,0-27.33l4.79-37.66s-.73-63.89,6.28-75c6.06-9.57,7.45-26.38,7.72-30.79,0-.7.06-1.09.06-1.09l10.68-12.8s103.4-7.75,111.15,0c1.91,1.91,3.08,6.23,3.78,11.68,2.13,16.75-.31,44.07-.31,44.07s-3.1,20.31-7.53,41a89.59,89.59,0,0,0,0,37.66A112.53,112.53,0,0,0,1036.67,671.91Z"
              transform="translate(-59.52 -31.65)"
              fill="#65617d"
            />
            <path
              d="M1030.21,833.83c-4.62,6.09-31.76,3.5-36.38,1.61-2.82-1.17-2.6-6.47-1.84-11.94.48-3.48,1.19-7,1.48-9.61.74-6.65-2.22-20.13-2.22-20.13s6.1,6.46,7.57,0c.65-2.82,2.92-4.27,5.27-5a13.85,13.85,0,0,1,9.59.6c4.79,2.08,12.8,6.52,11.36,12.52-2,8.48,5.17,20.51,5.17,20.51a9.36,9.36,0,0,1,1.34,2.32A8.88,8.88,0,0,1,1030.21,833.83Z"
              transform="translate(-59.52 -31.65)"
              fill="#a27772"
            />
            <path
              d="M1030.21,833.83c-4.62,6.09-31.76,3.5-36.38,1.61-2.82-1.17-2.6-6.47-1.84-11.94,2.91,1.36,7.87,2.5,16.13,1.73a46.94,46.94,0,0,1,5.81-.18,134.05,134.05,0,0,0,17.62-.35A8.88,8.88,0,0,1,1030.21,833.83Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M935.49,679.3c1.85,24-.37,60.92-7.75,80.86a100.21,100.21,0,0,0-5.54,39.51c-2.58,2.18-6.17,2.55-10.05,1.93C914.38,786,923.87,718.92,930,665.91,936.88,605.54,969.28,564,969.28,564l6.46,7.11C958,580.33,935.49,679.3,935.49,679.3Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1019.13,291.21l-4.51,22.15-22.08,37.11-27.23-11.63s-37-38.77-13.75-44.31a20.39,20.39,0,0,0,7.72-3.44c4.57-3.44,6-8.45,6-13.35,0-8.09-3.78-15.89-3.78-15.89l47.63-15a76.08,76.08,0,0,0-3.42,19.3c-.36,13,4.46,19.36,8.41,22.41A14.44,14.44,0,0,0,1019.13,291.21Z"
              transform="translate(-59.52 -31.65)"
              fill="#fbbebe"
            />
            <path
              d="M1009.16,246.9a76.08,76.08,0,0,0-3.42,19.3,34.91,34.91,0,0,1-2.77,2.94,37.67,37.67,0,0,1-37.66,8.6c0-8.09-3.78-15.89-3.78-15.89Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1014.62,240.81A37.66,37.66,0,1,1,977,203.14,37.5,37.5,0,0,1,1014.62,240.81Z"
              transform="translate(-59.52 -31.65)"
              fill="#fbbebe"
            />
            <path
              d="M1019.13,291.21l-4.51,22.15-22.08,37.11-27.23-11.63s-37-38.77-13.75-44.31a20.39,20.39,0,0,0,7.72-3.44c-4.2,11.55,13.14,35.57,13.14,35.57,2,3,6.65,1.1,6.65,1.1,11.16-1.68,31.73-33.81,35.08-39.15A14.44,14.44,0,0,0,1019.13,291.21Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1040.45,506c-6.55,1.49-42.83,9.53-56.59,7.52-15.13-2.22-44.57-3.69-44.57-3.69s-18.74,1-24.51-1.62c0-.7.06-1.09.06-1.09l10.68-12.8s103.4-7.75,111.15,0C1038.58,496.21,1039.75,500.53,1040.45,506Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M972.42,327.76s-19.48-27-12.14-37.49l-32.91,13.49s-19.81-2.4-27,27.16a51.13,51.13,0,0,0-1.23,15c.26,4.46-.34,12.31-5.42,22.46-8.13,16.25-6.28,53.54,10.34,57.24s22.52,1.84,22.52,1.84-2.21,67.58-11.81,75.33,24.47,5.91,24.47,5.91,29.44,1.48,44.58,3.69,57.6-7.75,57.6-7.75-6.28-28.44-8.49-46.53-7.39-56.62-7.39-56.62l37.67-51s6.64-30.83-16.62-44.49-32-17-32-17S991.25,327,979.07,328.87C979.07,328.87,974.44,330.73,972.42,327.76Z"
              transform="translate(-59.52 -31.65)"
              fill="#7c7cdd"
            />
            <path
              d="M929.22,338.47s-.37,12.19,1.84,17,10.34,31.39,10.34,31.39H922.94s10-10.71,9.23-15.88S929.22,338.47,929.22,338.47Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M983.87,430.42s-40.78-10-44.58-18.47S925,384.46,925,384.46l4.3-5.8,19.84,15.57s23.63,18.83,34.71,20.68S983.87,430.42,983.87,430.42Z"
              transform="translate(-59.52 -31.65)"
              fill="#fbbebe"
            />
            <path
              d="M983.87,430.42s-40.78-10-44.58-18.47S925,384.46,925,384.46l4.3-5.8,19.84,15.57s23.63,18.83,34.71,20.68S983.87,430.42,983.87,430.42Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.05"
            />
            <path
              d="M1019.13,382.42v22.12h-3.56a103.54,103.54,0,0,0-50.21,13l-6.66,3.7-1.79,1-11.45-25.78,10.71-9.6.55,0c2.62.25,13.95,1.2,18.75-.42,4.56-1.55,10.22-6.46,23.65-3,6.62,1.69,12.27,9.11,18.69,6.79Z"
              transform="translate(-59.52 -31.65)"
              fill="#fbbebe"
            />
            <path
              d="M1054.76,342.17l7.39,8.3V370.6s-6.28,63.51-26.22,70.53-55.53-4.07-55.53-4.07-9.2-24.37-4.9-25.84,38-10.38,38-10.38-.47-37.26,6.91-48.34c0,0-4.8-34.7,11.82-35.44S1054.76,342.17,1054.76,342.17Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1055.87,342.17l7.39,8.3V370.6S1057,434.11,1037,441.13s-55.54-4.07-55.54-4.07-9.19-24.37-4.89-25.84,38-10.38,38-10.38-.48-37.26,6.91-48.34c0,0-4.8-34.7,11.82-35.44S1055.87,342.17,1055.87,342.17Z"
              transform="translate(-59.52 -31.65)"
              fill="#7c7cdd"
            />
            <path
              d="M1004.29,256.81c.15-2.43.2-5-.84-7.19s-3.48-3.94-5.86-3.38c-3.16.74-4.52,4.85-7.62,5.84-2.61.83-5.46-1-6.7-3.46s-1.28-5.3-1.29-8c0-3.08,0-6.17,0-9.25,0-3.36-.11-7-2.18-9.62-2.57-3.29-8.62-4.72-12.66-4.59a10.72,10.72,0,0,0-7.23,2.92c-2.16,1.83-4.66,3.19-7.61,2.7a6.57,6.57,0,0,1-5.3-4.58l0-.12a37.66,37.66,0,1,1,56,50A100.66,100.66,0,0,0,1004.29,256.81Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M952.28,221.64a6.58,6.58,0,0,1-5.3-4.59c-.31-1.19-.23-2.46-.58-3.65-.86-2.9-4-4.41-6-6.61-4.16-4.42-3.89-11.68-.94-17,2.38-4.28,7-7.89,11.81-7.06,3,.52,5.57,2.65,8.6,2.84s5.57-1.45,8.23-2.66a31,31,0,0,1,20.41-1.81,11.87,11.87,0,0,1,5.62,2.83,50,50,0,0,1,3,4.21c3.45,4.39,9.61,5.25,15.1,6.24s11.69,3.16,13.5,8.44c1.19,3.5,0,7.3-.65,10.94a3.16,3.16,0,0,0,.14,2.25c.86,1.42,3,.83,4.62,1.17,3.12.65,3.92,4.66,4,7.84q.2,5.46.3,10.92a10.73,10.73,0,0,1-3.47,9.13l-12.19,14.65c-5.41,6.5-11.15,14.07-10.06,22.45-2.56,1.15-5.6-1.07-6.44-3.75s-.16-5.56.4-8.31a101.72,101.72,0,0,0,1.93-14.42c.15-2.44.2-5-.84-7.19s-3.48-4-5.86-3.39c-3.16.74-4.52,4.85-7.62,5.84-2.6.83-5.46-1-6.7-3.46s-1.28-5.3-1.29-8l0-9.26c0-3.35-.11-7-2.18-9.62-2.57-3.29-8.62-4.72-12.66-4.59a10.74,10.74,0,0,0-7.23,2.92C957.73,220.77,955.23,222.12,952.28,221.64Z"
              transform="translate(-59.52 -31.65)"
              fill="#7c5c5c"
            />
            <path
              d="M960.79,337.55l11.56,47.5S981.47,385,960.79,337.55Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1000.3,329.61s-15.14,24.8-9.23,50.43l2.82.21S988.85,368.38,1000.3,329.61Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1009.9,469.93s18.59-6.15,19.94,8.12C1029.84,478.05,1026.33,468.27,1009.9,469.93Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M956.17,388s-3.69,25.85,3,36.19c0,0-13.52,5.54-32.5,4.43L924.42,388Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M958.7,421.23l-1.79,1-11.45-25.78,10.71-9.6h.55v0C956.55,388.09,953.57,410.29,958.7,421.23Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M956.17,386.85s-3.69,25.84,3,36.18c0,0-13.52,5.54-32.5,4.43l-12.92-40.61Z"
              transform="translate(-59.52 -31.65)"
              fill="#7c7cdd"
            />
            <path
              d="M924.23,818.11a8.35,8.35,0,0,1-7.17,7.31c-10,1.5-34.18,5.32-40.28,8.22-7.75,3.69-38.4,1.11-39.88-2.58a5.86,5.86,0,0,1,.53-4.44,11.91,11.91,0,0,1,5-5.33,12.27,12.27,0,0,1,2.22-1c5.77-1.93,16.67-6,19.62-10.3,0,0,13.59-11.89,17.46-18.32a8.89,8.89,0,0,1,7.1-4.42c3.24-.15,6.84,1.48,8.31,8.57,0,0,17.72,10.11,22.51,1.24,0,0,.74,13.62,3.68,17.34l0,0A4.94,4.94,0,0,1,924.23,818.11Z"
              transform="translate(-59.52 -31.65)"
              fill="#a27772"
            />
            <path
              d="M924.23,818.11a8.35,8.35,0,0,1-7.17,7.31c-10,1.5-34.18,5.32-40.28,8.22-7.75,3.69-38.4,1.11-39.88-2.58a5.86,5.86,0,0,1,.53-4.44,11.91,11.91,0,0,1,5-5.33c5,3.32,16.09,6.56,40.49,2.75,23.27-3.63,34.79-7.19,40.41-9.62l0,0A4.94,4.94,0,0,1,924.23,818.11Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <g opacity="0.1">
              <path
                d="M1025,214.3l0-.18c.53-2.77,1.32-5.63,1.14-8.39a53.74,53.74,0,0,1-1.14,6.73A4.09,4.09,0,0,0,1025,214.3Z"
                transform="translate(-59.52 -31.65)"
              />
              <path
                d="M1003.44,248.86a10.88,10.88,0,0,1,.91,4.22,12.58,12.58,0,0,0-.91-5.88c-1-2.21-3.47-3.95-5.85-3.39-3.16.74-4.52,4.85-7.62,5.84-2.61.83-5.46-1-6.71-3.46s-1.27-5.3-1.28-8c0-3.09,0-6.17,0-9.26,0-3.35-.11-7-2.18-9.62-2.57-3.29-8.63-4.72-12.66-4.59a10.72,10.72,0,0,0-7.23,2.92c-2.17,1.84-4.66,3.19-7.61,2.71a6.58,6.58,0,0,1-5.3-4.59c-.31-1.19-.23-2.46-.58-3.65-.87-2.9-4-4.41-6-6.61a12,12,0,0,1-3.11-7.81,12.58,12.58,0,0,0,3.11,9.47c2.08,2.2,5.17,3.72,6,6.62.35,1.18.27,2.45.58,3.64a6.58,6.58,0,0,0,5.3,4.59c3,.48,5.44-.87,7.61-2.71a10.72,10.72,0,0,1,7.23-2.92c4-.13,10.09,1.31,12.66,4.59,2.07,2.64,2.17,6.27,2.18,9.62,0,3.09,0,6.17,0,9.26,0,2.74,0,5.59,1.28,8s4.1,4.29,6.71,3.46c3.1-1,4.46-5.1,7.62-5.84C1000,244.92,1002.41,246.65,1003.44,248.86Z"
                transform="translate(-59.52 -31.65)"
              />
              <path
                d="M1033.79,238.69a14.17,14.17,0,0,1-3.14,5.08q-6.09,7.33-12.19,14.65c-5.13,6.17-10.57,13.31-10.17,21.18.37-7.22,5.4-13.79,10.17-19.52l12.19-14.64a14.3,14.3,0,0,0,3.14-5.09,13.74,13.74,0,0,0,.32-4A9.62,9.62,0,0,1,1033.79,238.69Z"
                transform="translate(-59.52 -31.65)"
              />
              <path
                d="M1002,277.12a8.77,8.77,0,0,1-.36-2,10,10,0,0,0,.36,3.64c.84,2.68,3.89,4.89,6.45,3.74-.07-.54-.11-1.08-.13-1.62C1005.74,281.94,1002.78,279.76,1002,277.12Z"
                transform="translate(-59.52 -31.65)"
              />
            </g>
            <path
              d="M879.26,795s3.86,6.79,17.84.81"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M997.5,796.67s12.06,14.2,27.26,4.65"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1032.61,628.7s-8.53,5.33-8.8,8.38,4.4-2.22,4.4-2.22Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1036,669.53a17.81,17.81,0,0,1-10.5,4.1c-6.37.28-5.84,8.59-1.68,6.09S1036,669.53,1036,669.53Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M1037.59,674.86s-4.09,20.1-7.41,16.22"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M196.28,768.36s5.49,7.18-2.54,18-14.65,20-12,26.76c0,0,12.11-20.14,22-20.42S207.13,780.47,196.28,768.36Z"
              transform="translate(-59.52 -31.65)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M196.28,768.36a8.63,8.63,0,0,1,1.12,2.25c9.62,11.3,14.75,21.85,5.5,22.12-8.61.24-19,15.65-21.42,19.54a9.06,9.06,0,0,0,.29.88s12.11-20.14,22-20.42S207.13,780.47,196.28,768.36Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M206.49,777.51c0,2.53-.28,4.58-.63,4.58s-.64-2.05-.64-4.58.36-1.33.71-1.33S206.49,775,206.49,777.51Z"
              transform="translate(-59.52 -31.65)"
              fill="#ffd037"
            />
            <path
              d="M210,780.53c-2.22,1.21-4.16,1.94-4.33,1.64s1.5-1.54,3.72-2.75,1.34-.33,1.51,0S212.22,779.32,210,780.53Z"
              transform="translate(-59.52 -31.65)"
              fill="#ffd037"
            />
            <path
              d="M167.26,768.36s-5.49,7.18,2.54,18,14.65,20,12,26.76c0,0-12.11-20.14-22-20.42S156.42,780.47,167.26,768.36Z"
              transform="translate(-59.52 -31.65)"
              class="dynamic-svg"
              fill="#6c63ff"
            />
            <path
              d="M167.26,768.36a9,9,0,0,0-1.12,2.25c-9.62,11.3-14.75,21.85-5.5,22.12,8.62.24,19,15.65,21.42,19.54a7,7,0,0,1-.29.88s-12.11-20.14-22-20.42S156.42,780.47,167.26,768.36Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.1"
            />
            <path
              d="M157.05,777.51c0,2.53.28,4.58.63,4.58s.64-2.05.64-4.58-.36-1.33-.71-1.33S157.05,775,157.05,777.51Z"
              transform="translate(-59.52 -31.65)"
              fill="#ffd037"
            />
            <path
              d="M153.55,780.53c2.22,1.21,4.15,1.94,4.32,1.64s-1.5-1.54-3.72-2.75-1.34-.33-1.51,0S151.33,779.32,153.55,780.53Z"
              transform="translate(-59.52 -31.65)"
              fill="#ffd037"
            />
            <path
              d="M158.8,812.21s15.36-.47,20-3.77,23.62-7.23,24.77-1.94,23.08,26.29,5.74,26.43-40.29-2.7-44.91-5.52S158.8,812.21,158.8,812.21Z"
              transform="translate(-59.52 -31.65)"
              fill="#a8a8a8"
            />
            <path
              d="M209.61,831.09c-17.34.14-40.29-2.7-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38l-.51,0s1,12.39,5.59,15.2,27.57,5.66,44.91,5.52c5,0,6.74-1.82,6.64-4.46C215.25,830.06,213.34,831.06,209.61,831.09Z"
              transform="translate(-59.52 -31.65)"
              opacity="0.2"
            />
          </svg>
        </div>
      </div>
    </div>

    <!---------------------------------------------------------->
    <div class="landing-page-5">
      <h1 class="text-center landing-page-5-title my-4">
        Get started right now with no requirements!
      </h1>
      <router-link
        id=""
        class="btn btn-md mx-2 landing-page-5-btns"
        tag="btn"
        to="/login"
        ><strong>Log In</strong></router-link
      >
      <router-link
        id=""
        class="btn btn-md mx-2 landing-page-5-btns"
        tag="btn"
        to="/register"
        ><strong>Sign Up</strong></router-link
      >
    </div>
    <!--<br>-->
    <!--<br>-->
    <!---->
    <div class="footerApp">
      <footerApp></footerApp>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import footerApp from "../components/footer.vue";

export default {
  name: "home",
  components: {
    // HelloWorld
    footerApp
  },
  data() {
    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN
      landing_page_1:
        "Hire freelnacers to your dream's project or start working on projects as a freelancer, thats the benefit of using this simple app!",
      landing_page_2:
        "You could use our GrapqQL Api for query your data about project users and you would be able to use them in your project simpliest way to query them!",
      landing_page_3: null,
      landing_page_4: null,
      landing_page_5: null
    };
  },
  created() {
    // CHECK USER IF AUTHENTICATED
    if (this.token) {
      this.$router.push("projects");
    }
  }
};
</script>
<style scoped>
.home {
  color: rgba(0, 0, 0, 0.89);
}
.graphql-color {
  color: #e535ab;
}
.dynamic-svg {
  fill: var(--primary-color) !important;
}
.primary {
  color: var(--primary-color);
}
.red {
  color: var(--dan-ger);
}
.margin-between-sections {
  margin-bottom: 150px !important;
}
.landing-page {
  background-image: url(".././assets/pcgamercoding.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 90vh;
  padding-top: 12%;
  /*backdrop-filter: blur(20px)!important;*/
}
.credit-img-owner {
  position: absolute;
  top: 90%;
  /*left: 70%;*/
}

.main-title {
  font-size: 60px;
}
.red {
  background-color: var(--dan-ger);
}
.primary {
  background-color: var(--primary-color);
}
.red-color {
  color: var(--dan-ger);
}
.primary-color {
  color: var(--primary-color);
}
.none {
  display: none;
}
.block {
  display: block;
}
.footerApp {
  margin-top: 100px;
}
.landing-page-1 {
  padding-top: 20px;
}
.landing-page-5 {
  padding-top: 60px;
  background-color: var(--primary-color);
  height: 300px;
  color: white;
}
.image {
  width: 100%;
  height: 100%;
}
.landing-page-5-btns {
  background-color: white !important;
  color: var(--primary-color) !important;
}
@media only screen and (max-width: 600px) {
  .svg-section {
    display: none;
  }
  .landing-page-5-title {
    font-size: 30px;
  }
  .main-title {
    font-size: 30px;
  }
  .landing-page {
    padding-top : 40% ;
  }
}
</style>
